export enum IndustryType {
  AEROSPACE_INDUSTRY,
  AGRICULTURE,
  CHEMICAL_INDUSTRY,
  COMPUTER_INDUSTRY,
  CONSTRUCTION_INDUSTRY,
  DEFENSE_INDUSTRY,
  EDUCATION_INDUSTRY,
  ENERGY_INDUSTRY,
  ENTERTAINMENT_INDUSTRY,
  FINANCIAL_SERVICES_INDUSTRY,
  FOOD_INDUSTRY,
  HEALTHCARE_INDUSTRY,
  HOSPITALITY_INDUSTRY,
  INFORMATION_INDUSTRY,
  MANUFACTURING,
  MASSMEDIA,
  MINING,
  TELECOMMUNICATIONS_INDUSTRY,
  TRANSPORT_INDUSTRY

}
